<div class="chip-group">
  <span *ngIf="caption" class="chip-group-caption">{{ caption }}</span>
  <div class="chip-group-items">
    <ng-content></ng-content>
  </div>
</div>
